import common from "../../utill/Common";
import axios from "axios";

class LeadManagementService {
  addLeadProduct = async (
    token,
    category_id,
    name,
    title,
    sub_title,
    logo,
    payout_type,
    earn_upto,
    base_earning,
    base_earning_note,
    bonus_earning,
    bonus_earning_note,
    data,
    status,
    source_type,
    utm_fetch_type,
    utm_link,
    banksathi_config
  ) => {
    const url = common.baseUrl + "admin/lead_management/add_lead_product";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        category_id,
        name,
        title,
        sub_title,
        logo,
        payout_type,
        earn_upto,
        base_earning,
        base_earning_note,
        bonus_earning,
        bonus_earning_note,
        data,
        status,
        source_type,
        utm_fetch_type,
        utm_link,
        banksathi_config,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  updateLeadProduct = async (
    token,
    id,
    category_id,
    name,
    title,
    sub_title,
    logo,
    payout_type,
    earn_upto,
    base_earning,
    base_earning_note,
    bonus_earning,
    bonus_earning_note,
    data,
    status,
    source_type,
    utm_fetch_type,
    utm_link,
    banksathi_config
  ) => {
    const url = common.baseUrl + "admin/lead_management/update_lead_product";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        id,
        category_id,
        name,
        title,
        sub_title,
        logo,
        payout_type,
        earn_upto,
        base_earning,
        base_earning_note,
        bonus_earning,
        bonus_earning_note,
        data,
        status,
        source_type,
        utm_fetch_type,
        utm_link,
        banksathi_config,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  deleteLeadProduct = async (token, id) => {
    const url = common.baseUrl + "admin/lead_management/delete_lead_product";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchProducts = async (
    token,
    category_id,
    search_text,
    status,
    page,
    size
  ) => {
    const url = common.baseUrl + "admin/lead_management/fetch_products";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        category_id,
        search_text,
        status,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchAllProducts = async (token) => {
    const url = common.baseUrl + "admin/lead_management/fetch_all_products";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({}),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchProductById = async (token, id) => {
    const url = common.baseUrl + "admin/lead_management/fetch_product_by_id";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchCategories = async (token, id) => {
    const url = common.baseUrl + "admin/lead_management/fetch_categories";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        id,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  addCommercial = async (token, newData) => {
    const url = common.baseUrl + "admin/lead_management/commercial/add";

    try {
      const response = await axios.post(url, newData, {
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      });

      if (!response.status || !response.data) {
        throw new Error("Request Failed!");
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  updateCommercial = async (token, newData) => {
    const url = common.baseUrl + "admin/lead_management/commercial/update";

    try {
      const response = await axios.post(url, newData, {
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      });

      if (!response.status || !response.data) {
        throw new Error("Request Failed!");
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  fetchCommercial = async (token, package_id, product_id) => {
    const url = common.baseUrl + "admin/lead_management/commercial/fetch";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ package_id, product_id }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  deleteCommercial = async (token, id) => {
    const url = common.baseUrl + "admin/lead_management/commercial/delete";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  deletePackage = async (token, id) => {
    const url = common.baseUrl + "admin/lead_management/package/delete";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  addPackage = async (token, name, description) => {
    const url = common.baseUrl + "admin/lead_management/package/add";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        token,
        name,
        description,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  updatePackage = async (token, id, name, description) => {
    const url = common.baseUrl + "admin/lead_management/package/edit";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        token,
        id,
        name,
        description,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchPackageById = async (token, id) => {
    const url = common.baseUrl + "admin/lead_management/package/fetch_by_id";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  fetchAllPackages = async (token) => {
    const url = common.baseUrl + "admin/lead_management/package/fetch_all";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  syncProducts = async (token) => {
    const url = common.baseUrl + "admin/lead_management/sync_products";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };

  leadTransactions = async (
    token,
    from_date,
    to_date,
    status,
    category_id,
    product_id,
    user_id,
    search_text,
    page,
    size
  ) => {
    const url = common.baseUrl + "admin/lead_management/transactions";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({
        from_date,
        to_date,
        status,
        category_id,
        product_id,
        user_id,
        search_text,
        page,
        size,
      }),
    };

    const response = await fetch(url, options);

    return response.json();
  };

  updateLeadStatus = async (token, id, status, remark) => {
    const url = common.baseUrl + "admin/lead_management/update_lead_status";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: JSON.stringify({ id, status, remark }),
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new LeadManagementService();
